import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { applyFiltersAction } from 'src/routes/SearchPage/actions/mobile';
import { isAwaitingFiltration } from 'src/routes/SearchPage/searchStatus/selectors';
import { pluralize } from 'src/utils/stringUtils';
import { hotelsCountSelector } from 'src/routes/SearchPage/store/hotels/selectors';

function getButtonText(fetching, count) {
  if (fetching) {
    return 'Загрузка...';
  }
  return `${count ? `Показать ${count}` : 'Нет'} ${pluralize(count, [
    'отель',
    'отеля',
    'отелей',
  ])}`;
}

const className = 'lt-button';

const FiltersApply = ({ fetching, hotelsCount, applyFilters }) => {
  const buttonText = getButtonText(fetching, hotelsCount);
  const disabled = fetching || !hotelsCount;
  const buttonClassName = classNames({
    [`${className} ${className}__big`]: true,
    [`${className}__white`]: !hotelsCount,
  });

  return (
    <div className="filters__submit">
      <button
        type="button"
        className={buttonClassName}
        onClick={applyFilters}
        disabled={disabled}
      >
        {buttonText}
      </button>
    </div>
  );
};

FiltersApply.propTypes = {
  fetching: PropTypes.bool,
  applyFilters: PropTypes.func.isRequired,
  hotelsCount: PropTypes.number.isRequired,
};

FiltersApply.defaultProps = {
  fetching: false,
};

const mapStateToProps = (state) => ({
  hotelsCount: hotelsCountSelector(state),
  fetching: isAwaitingFiltration(state),
});

const mapDispatchToProps = (dispatch) => ({
  applyFilters: () => dispatch(applyFiltersAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FiltersApply);
